import type { BuildingId, CitizenId, VehicleId } from '../types/core';

export function buildingId(seed: string): BuildingId {
  return `building-${seed}` as BuildingId;
}

export function citizenId(seed: string): CitizenId {
  return `citizen-${seed}` as CitizenId;
}

export function vehicleId(seed: string): VehicleId {
  return `vehicle-${seed}` as VehicleId;
}
